module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAbCAYAAACAyoQSAAAAqElEQVRIS2NkaDjzn4HOgHHUUlqG+Gjw0jJ0GUaDd3AF74N8XYaWw88Z5p1/w/CPzLKM5Dj9X28MDoVTT78y5G5/xHDq6TeSQ4VsS0E2/fv/n2H++bcMlXufMrz+9odoyymyFGbLzTc/GDSmXqWPpWCfXnjLULmHTj49/fQrQw694vRhgS5D8yE6p16iIw6PQpIT0qilpITAaPCSElokqx0NXpKDjBQNAF/lfgVcOjXOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/turnright.png
// module id = 8MWQ
// module chunks = 1